import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const AudioProcessConfig = [
  {
    routes: [
      {
        path: '/PresProcessingPage',
        component: React.lazy(() => import('./ProcessingPage')),
      },
    ],
  },
];
